import React from "react";
import { Card, Typography } from "antd";
import CommonTable from "../CommonTable";
import dayjs from "dayjs";
const Medications = ({ data }) => {
  const columns = [
    {
      title: "Time Done",
      dataIndex: "process_time",
      key: "process_time",
      render: (value, record) => dayjs(value)?.format("DD, MMM hh:mm A"),
    },
  ];
  const filteredData = data?.filter(
    (item) =>
      !(item?.frequency === "If_Required" || item?.frequency === "Immediately")
  );
  const sosData = data?.filter(
    (item) =>
      item?.frequency === "If_Required" || item?.frequency === "Immediately"
  );
  return (
    <div>
      {filteredData?.map((item) => (
        <Card title={item?.name} style={{ marginTop: "10px" }}>
          <CommonTable data={item?.actions} columns={columns} />
        </Card>
      ))}
      {sosData?.map((item) => (
        <Card title={item?.name} style={{ marginTop: "10px" }}>
          <CommonTable
            data={
              item?.actions?.flatMap((action) =>
                Array.isArray(action?.nurse_data)
                  ? action?.nurse_data
                  : action?.nurse_data
                  ? [action?.nurse_data]
                  : []
              ) ?? []
            }
            columns={columns}
          />
        </Card>
      ))}
    </div>
  );
};

export default Medications;
